"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tronConnectorFactory = exports.createTronOfflineConnectorHelper = void 0;
const Errors_1 = require("../../../Errors");
const AxiosRateLimiter_1 = require("../../../Utils/AxiosRateLimiter");
const TronOfflineConnector_1 = require("./Offline/TronOfflineConnector");
// share rate limiter across all offline connectors to limit requests globally
const tronGridRateLimiter = new AxiosRateLimiter_1.AxiosConcurrencyHandler(10, 1000);
const createTronOfflineConnectorHelper = (name, tronWebParams) => {
    return (config) => new TronOfflineConnector_1.TronOfflineConnector(config, {
        name,
        displayName: name,
        isWallet: false,
    }, Object.assign(Object.assign({}, tronWebParams), { rateLimiter: tronWebParams.rateLimiter || tronGridRateLimiter }));
};
exports.createTronOfflineConnectorHelper = createTronOfflineConnectorHelper;
const tronConnectorFactory = (config, metadata, params) => {
    if (metadata.isWallet) {
        throw new Errors_1.WalletFactoryNotImplemented(config.blockchain);
    }
    params.rateLimiter = params.rateLimiter || tronGridRateLimiter;
    return new TronOfflineConnector_1.TronOfflineConnector(config, metadata, params);
};
exports.tronConnectorFactory = tronConnectorFactory;
